/* INTEGY V636 — stock-ownership correction and legacy V596 consolidation.
   V577/V634 remains the only stock-result owner on the indexed master collections.
   This replaces the old V596 runtime without changing its unrelated navigation fixes.
   - never treats stock-verified=true as "available"; it means verification completed
   - never treats stock-verified=false as "sold out"; it means verification pending
   - indexed Traxxas/master grids are not stock-filtered or deduped by this safety layer
   - indexed filter/pagination links retain integy_stock instead of native availability
   - native Shopify collections retain conservative leak suppression and SKU dedupe
   - avoids a MutationObserver rerun for every live-stock verification on indexed grids */
(function(){
  'use strict';
  if(window.IntegyV636Release)return;
  window.IntegyV636Release={version:'V636',data:'V41-20260908',filterOwner:'V577',stockOwner:'V577/V634',purpose:'single-stock-owner-native-safety-navigation-reliability'};
  /* Compatibility alias: older diagnostics may still look for this object. */
  window.IntegyV596Release=window.IntegyV596Release||window.IntegyV636Release;
  document.documentElement.classList.add('integy-v596-runtime','integy-v636-runtime');

  function v626Root(){try{var r=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root;if(r)return r.charAt(r.length-1)==='/'?r:r+'/'}catch(e){}return'/'}
  function text(v){return String(v==null?'':v).replace(/\s+/g,' ').trim();}
  function cards(scope){try{return Array.prototype.slice.call((scope||document).querySelectorAll('[data-product-item],.productgrid--item'));}catch(e){return[];}}
  function sku(card){
    var s=text(card.getAttribute('data-sku')||card.getAttribute('data-product-sku')||'').toUpperCase();
    if(s)return s;
    var n=card.querySelector('[data-sku],.integy-product-card-sku,.productitem--sku');
    return text(n&&((n.getAttribute&&n.getAttribute('data-sku'))||n.textContent)||'').replace(/^SKU:\s*/i,'').toUpperCase();
  }
  function hide(card,reason){card.hidden=true;card.setAttribute('aria-hidden','true');card.setAttribute('data-integy-v636-suppressed',reason);}
  function currentStock(){
    try{var q=new URLSearchParams(location.search||''),s=(q.get('integy_stock')||'').toLowerCase(),n=q.get('filter.v.availability')||'';if(s==='in'||s==='out'||s==='all')return s;if(n==='1')return'in';if(n==='0')return'out';}catch(e){}
    return'';
  }
  function collectionHandleFromUrl(value){
    try{var u=value instanceof URL?value:new URL(value||location.href,location.origin);var m=String(u.pathname||'').match(/^\/collections\/([^/?#]+)/i);return m?decodeURIComponent(m[1]).toLowerCase():'';}catch(e){return'';}
  }
  function indexedStockOwner(value){
    var h=collectionHandleFromUrl(value);
    if(/^(?:all-integy-hop-up-parts|hopups-for-traxxas|hop-up-parts-for-traxxas|parts-for-traxxas)$/.test(h))return true;
    if(h==='pinion-and-spur-gears-for-1-5-1-8-1-10-1-12-1-18-rc'){try{var u=value instanceof URL?value:new URL(value||location.href,location.origin);return !!(u.searchParams.get('integy_filter')||u.searchParams.get('integy_filters')||u.searchParams.get('integy_tag_filter'));}catch(e){return false;}}
    return false;
  }
  function explicitAvailability(card){
    var state=card&&card.getAttribute?card.getAttribute('data-product-available'):'';
    if(state==='true')return true;
    if(state==='false')return false;
    return null;
  }
  function isProvenSoldOut(card){
    var explicit=explicitAvailability(card);
    if(explicit!==null)return explicit===false;
    /* V636: false means pending verification, never sold out. */
    if(card.getAttribute('data-integy-v548-stock-verified')==='false')return false;
    var t=text(card.textContent).toLowerCase();
    return /(?:^|\b)(?:sold out|out of stock|unavailable)(?:\b|$)/.test(t);
  }
  function isProvenAvailable(card){
    var explicit=explicitAvailability(card);
    if(explicit!==null)return explicit===true;
    /* V636: a completed-verification flag does not encode the stock result. */
    if(card.getAttribute('data-integy-v548-stock-verified')==='false')return false;
    if(isProvenSoldOut(card))return false;
    var t=text(card.textContent).toLowerCase();
    return /\badd to cart\b/.test(t)||!!card.querySelector('form[action*="/cart/add"] button:not([disabled]),[data-product-atc]:not([disabled])');
  }
  function repairLinks(card,s){
    if(s!=='C33658GREY')return;
    Array.prototype.slice.call(card.querySelectorAll('a[href]')).forEach(function(a){
      try{var u=new URL(a.getAttribute('href'),location.origin);if(/\/products\/trx-maxx-4s-c33658green\/?$/i.test(u.pathname))a.setAttribute('href',v626Root()+'products/trx-maxx-4s-c33658grey'+u.search+u.hash);}catch(e){}
    });
  }
  function sanitize(scope){
    if(!/\/collections\//i.test(location.pathname||''))return;
    var indexed=indexedStockOwner(location.href),seen=Object.create(null),mode=currentStock();
    /* INTEGY V700 — V696 owns /collections/all stock membership and exact-SKU
       dedupe from live row-level availability. This native safety layer must not
       hide or dedupe those already-authoritative cards. */
    if(liveLargeCustomStockOwner(location.href) && (window.IntegyV651LargeStockOwnerActive || document.querySelector('[data-integy-v651-large-owner="true"]'))) return;
    cards(scope||document).forEach(function(card){
      var s=sku(card);if(!s)return;repairLinks(card,s);
      /* V636: V577 owns indexed stock membership, live verification, rescue,
         ordering and dedupe. This legacy safety pass must never hide those cards. */
      if(indexed)return;
      if(mode==='in'&&isProvenSoldOut(card)){hide(card,'native-in-stock-leak:'+s);return;}
      if(mode==='out'&&isProvenAvailable(card)){hide(card,'native-out-stock-leak:'+s);return;}
      if(seen[s]){hide(card,'native-duplicate-sku:'+s);return;}seen[s]=1;
    });
  }
  function clearanceCustomStockOwner(value){
    return collectionHandleFromUrl(value)==='on-sale-clearance-up-to-80';
  }
  function liveLargeCustomStockOwner(value){
    return collectionHandleFromUrl(value)==='all';
  }
  function applyStockToUrl(u,mode){
    if(indexedStockOwner(u)||clearanceCustomStockOwner(u)||liveLargeCustomStockOwner(u)){
      u.searchParams.delete('filter.v.availability');
      u.searchParams.delete('integy_include_sold_out');
      u.searchParams.set('integy_stock',mode==='all'?'all':mode==='out'?'out':'in');
      return;
    }
    u.searchParams.delete('integy_stock');
    u.searchParams.delete('integy_include_sold_out');
    if(mode==='all')u.searchParams.delete('filter.v.availability');
    else u.searchParams.set('filter.v.availability',mode==='out'?'0':'1');
  }
  function preserveStockOnFilterLinks(scope){
    var mode=currentStock();if(!mode)return;
    var sel='a[href*="integy_filter="],a[href*="integy_filters="],a[href*="integy_tag_filter="]';
    Array.prototype.slice.call((scope||document).querySelectorAll(sel)).forEach(function(a){
      try{
        /* V689: filtered pagination links also contain integy_filter=. They are
           pagination state, not filter-selection links, so never reset page=N here. */
        if(a.closest&&a.closest('.pagination,.pagination--container,.pagination-wrapper,.integy-v426-filter-pagination,.integy-v458-vehicle-pagination'))return;
        var raw=a.getAttribute('href')||'';if(!raw||raw.charAt(0)==='#'||/^javascript:/i.test(raw))return;
        var u=new URL(raw,location.origin);if(!/\/collections\//i.test(u.pathname))return;
        u.searchParams.delete('page');
        applyStockToUrl(u,mode);
        var next=u.pathname+(u.search?'?'+u.searchParams.toString():'')+u.hash;
        if(raw!==next)a.setAttribute('href',next);
      }catch(e){}
    });
  }
  function preserveStockOnPagination(scope){
    var mode=currentStock();if(!mode)return;
    Array.prototype.slice.call((scope||document).querySelectorAll('.pagination--container a[href],.pagination a[href],.integy-v426-filter-pagination a[href]')).forEach(function(a){
      try{
        var raw=a.getAttribute('href')||'',u=new URL(raw,location.origin);if(!/^\/collections\//i.test(u.pathname))return;
        applyStockToUrl(u,mode);
        var next=u.pathname+(u.search?'?'+u.searchParams.toString():'')+u.hash;if(raw!==next)a.setAttribute('href',next);
      }catch(e){}
    });
  }
  function fixNav(scope){
    try{Array.prototype.slice.call((scope||document).querySelectorAll('header a,nav a,[data-mobile-nav] a,[data-navmenu-submenu] a')).forEach(function(a){
      var t=text(a.textContent),l=t.toLowerCase();if(l.indexOf('st rally')<0&&l.indexOf('ford fiesta')<0)return;
      var out=t;
      if(/bl[- ]?2s|\behd\b/i.test(t))out='1/10 Ford Fiesta ST Rally BL-2s (EHD)';
      else if(/2023/i.test(t))out='1/10 Ford Fiesta ST Rally (-2023)';
      else if(!/ford fiesta/i.test(t))out=t.replace(/st rally/i,'Ford Fiesta ST Rally');
      if(out!==t)a.textContent=out;
    });}catch(e){}
  }
  var queued=false;
  function run(){queued=false;sanitize(document);preserveStockOnFilterLinks(document);preserveStockOnPagination(document);fixNav(document);}
  function schedule(){if(queued)return;queued=true;(window.requestAnimationFrame||setTimeout)(run,16);}
  function boot(){
    run();
    if(window.MutationObserver){
      var targets=[document.querySelector('[data-productgrid-outer]'),document.querySelector('header'),document.querySelector('[data-mobile-nav]')].filter(Boolean);
      var indexed=indexedStockOwner(location.href),seen=[];
      targets.forEach(function(target){
        if(seen.indexOf(target)>=0)return;seen.push(target);
        new MutationObserver(function(mutations){
          /* On indexed pages live verification can mutate 72+ cards. V636 does
             not own stock there, so ignore verification-only churn completely. */
          if(indexed){
            var meaningful=mutations.some(function(m){return m.type==='childList'||m.attributeName==='href'||m.attributeName==='data-integy-v307-key'||m.attributeName==='data-integy-v634-stock-settled';});
            if(!meaningful)return;
          }
          schedule();
        }).observe(target,{childList:true,subtree:true,attributes:true,attributeFilter:['data-integy-v307-key','data-integy-v548-stock-verified','data-integy-v634-stock-settled','href']});
      });
    }
    window.addEventListener('popstate',schedule);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
